import { ActionReducerMap } from '@ngrx/store';
import {
  billingBalanceReducer,
  BillingBalanceState,
} from './billing-balance.reducer';
import {
  billingTransactionsReducer,
  BillingTransactionsState,
} from './billing-transactions.reducer';
import {
  billingPaymentInfoReducer,
  BillingPaymentInfoState,
} from './billing-payment-info.reducer';
import {
  customerAccountReducer,
  CustomerAccountState,
} from './customer-account.reducer';
import { callDetailsReducer, CallDetailsState } from './call-details.reducer';
import {
  promiseOfPaymentReducer,
  PromiseOfPaymentState,
} from './promise-of-payment.reducer';
import { PaymentDataState, paymentDataReducer } from './payment.reducer';
import {
  categoryDetailsReducer,
  IBillCategoryDetailsState,
} from './category-details.reducer';
import {
  odbCategoryDetailsReducer,
  IOdbBillCategoryDetailsState,
} from './odb-category-details.reducer';

import {
  appInitializationReducer,
  AppInitializationState,
} from './app-initialization.reducer';
import {
  billingCoverReducer,
  BillingCoverState,
} from './billing-cover.reducer';
import { deferralReducer, DeferralState } from './deferral.reducer';
import {
  odbUsageLevel4Reducer,
  IOdbBillUsageLevel4State,
} from './odb-usage-level-4.reducer';
import { pdfDownloadReducer, PdfDownloadState } from './pdf-download.reducer';
import {
  billingAggregatorReducer,
  BillingAggregatorState,
} from './billing-aggregator.reducer';
import {
  extraCostConfigFileReducer,
  ExtraCostConfigFileState,
} from './extra-cost.reducer';
import {
  billingTransactionsReferencesReducer,
  BillingTransactionsReferencesState,
} from './billing-transactions-references.reducer';

export const customerAccountFeatureKey = 'customerAccount';
export const billingBalanceFeatureKey = 'billingBalance';
export const billingTransactionsFeatureKey = 'billingTransactions';
export const billingPaymentInfoFeatureKey = 'billingPaymentInfo';
export const promiseOfPaymentFeatureKey = 'promiseOfPayment';
export const paymentDataFeatureKey = 'paymentData';
export const categoryDetailsFeatureKey = 'categoryDetails';
export const odbCategoryDetailsFeatureKey = 'odbCategoryDetails';
export const billingSummaryFeatureKey = 'billingSummary';
export const appInitializationFeatureKey = 'appInitialization';
export const billingCoverFeatureKey = 'billingCover';
export const deferralFeatureKey = 'deferral';
export const odbUsageLevel4FeatureKey = 'odbUsageLevel4';
export const pdfDownloadFeatureKey = 'pdfDownload';
export const billingAggregatorFeatureKey = 'billingAggregator';
export const extraCostConfigFileFeatureKey = 'extraCostConfigFile';
export const billingTransactionsReferencesFeatureKey =
  'billingTransactionsReferences';

export interface ApplicationState {
  customerAccount: CustomerAccountState;
  billingBalance: BillingBalanceState;
  billingTransactions: BillingTransactionsState;
  billingPaymentInfo: BillingPaymentInfoState;
  callDetails: CallDetailsState;
  promiseOfPayment: PromiseOfPaymentState;
  paymentData: PaymentDataState;
  categoryDetails: IBillCategoryDetailsState;
  odbCategoryDetails: IOdbBillCategoryDetailsState;
  appInitialization: AppInitializationState;
  billingCover: BillingCoverState;
  deferral: DeferralState;
  odbUsageLevel4: IOdbBillUsageLevel4State;
  pdfDownload: PdfDownloadState;
  billingAggregator: BillingAggregatorState;
  extraCostConfigFile: ExtraCostConfigFileState;
  billingTransactionsReferences: BillingTransactionsReferencesState;
}
export const reducers: ActionReducerMap<ApplicationState> = {
  customerAccount: customerAccountReducer,
  billingBalance: billingBalanceReducer,
  billingTransactions: billingTransactionsReducer,
  billingPaymentInfo: billingPaymentInfoReducer,
  callDetails: callDetailsReducer,
  promiseOfPayment: promiseOfPaymentReducer,
  paymentData: paymentDataReducer,
  categoryDetails: categoryDetailsReducer,
  odbCategoryDetails: odbCategoryDetailsReducer,
  appInitialization: appInitializationReducer,
  billingCover: billingCoverReducer,
  deferral: deferralReducer,
  odbUsageLevel4: odbUsageLevel4Reducer,
  pdfDownload: pdfDownloadReducer,
  billingAggregator: billingAggregatorReducer,
  extraCostConfigFile: extraCostConfigFileReducer,
  billingTransactionsReferences: billingTransactionsReferencesReducer,
};
